import {Close} from '@material-ui/icons';
import {Language} from '../../../context/LanguageContext';
import Cookies from 'js-cookie';
// import nookies from 'nookies';
import {Dropdown} from '../../../components';
import {useCallback, useEffect, useState} from 'react';
import {useArea, useUser} from '../../../hooks';
import {IconProfile} from '../../../assets';
import Swal from 'sweetalert2';

export default function FormPIC({type, onClose, data}) {
  const tokens_session = Cookies.get('token');
  // const cookies = nookies.get();
  // const tokens_session = cookies.token;
  const {language, newObj} = Language();
  const {createPIC, updatePIC} = useUser();
  const {getListPkCode} = useArea();
  const [pkCode, setPkCode] = useState([]);
  const [loading, setLoading] = useState(false);
  const [payload, setPayload] = useState({
    id: '',
    fullname: '',
    jawatan: '',
    pk_code: {
      label: newObj.PKKodWord[language],
      value: '',
    },
    email: '',
    phone: '',
    avatar: null,
    avatarPreview: '',
  });
  const [errorPayload, setErrorPayload] = useState({
    fullname: false,
    jawatan: false,
    email: false,
    phone: false,
  });
  const getDataPkCode = async () => {
    const {data} = await getListPkCode(tokens_session);
    setPkCode(
      data.data.map((item) => ({
        label: `${item.kodKawasa} ${item.namaKawasa}`,
        value: item.kodKawasa,
      })) || []
    );
  };
  const handleChangeInput = (e) => {
    const {name, value} = e.target;
    setPayload((prev) => ({...prev, [name]: value}));
  };

  const handleSubmit = useCallback(
    async (e) => {
      try {
        e.preventDefault();
        setLoading(true);
        console.log('payload submit', payload);
        const tempErrorPayload = {
          fullname: payload.fullname.trim() === '',
          jawatan: payload.jawatan.trim() === '',
          email: payload.email.trim() === '',
          phone: payload.phone.trim() === '',
        };
        setErrorPayload(tempErrorPayload);
        const hasError = Object.values(tempErrorPayload).some(
          (value) => value === true
        );

        if (
          hasError ||
          (payload.avatar instanceof File === false && !payload.avatarPreview)
        ) {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: newObj.PleaseFillInAllRequiredFieldsWord[language],
          });
          setLoading(false);
          return;
        }
        if (!data.selected._id)
          await createPIC(tokens_session, {
            ...payload,
            language: language == 1 ? 'en' : 'my',
          });
        else
          await updatePIC(tokens_session, {
            ...payload,
            language: language == 1 ? 'en' : 'my',
          });
      } catch (error) {
      } finally {
        setLoading(false);
        onClose();
      }
    },
    [tokens_session, payload, type, language, data.selected]
  );
  const handleChangeFile = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      setPayload((prev) => ({
        ...prev,
        avatar: file,
        avatarPreview: reader.result,
      }));
    };
  };
  useEffect(() => {
    if (data?.selected && pkCode.length > 0) {
      setPayload((prev) => ({
        ...prev,
        id: data.selected._id,
        fullname: data.selected.fullname,
        pk_code: data.selected.kodKawasan,
        nama_kawasan: data.selected.namaKawasan,
        jawatan: data.selected.jawatan,
        phone: data.selected.phone,
        email: data.selected.email,
        avatarPreview: data.selected.avatar,
      }));
    }
  }, [data?.selected, pkCode]);

  useEffect(() => {
    getDataPkCode(tokens_session);
  }, []);

  return (
    <div className='modal_content center add_new_user'>
      <div className='modal_header'>
        <p className='modal_title'>{newObj.PICWord[language]}</p>
        <Close
          style={{cursor: 'pointer'}}
          onClick={() => {
            onClose();
          }}
        />
      </div>
      <div className='modal_header'>
        <div className='modal_title'>
          <p>{data.selected.kodKawasan}</p>
          <p>{data.selected.namaKawasan}</p>
        </div>
      </div>
      <form action='POST' className='modal_body' onSubmit={handleSubmit}>
        <div className='left'>
          <div className='profile pic'>
            <div className='profile_img'>
              <img
                className='img'
                src={payload.avatarPreview || IconProfile}
                alt='avatar'
              />
              <input
                type='file'
                name='avatar'
                id=''
                accept='avatar/*'
                onChange={handleChangeFile}
              />
            </div>
          </div>
        </div>
        <div className='right'>
          <div className='list_pic_input'>
            <input
              type='text'
              name='email'
              className='item_pic_input'
              value={payload.email}
              placeholder={newObj.EmailWord[language]}
              onChange={handleChangeInput}
            />
            <input
              type='text'
              name='fullname'
              className='item_pic_input'
              value={payload.fullname}
              placeholder={newObj.NameWord[language]}
              onChange={handleChangeInput}
            />
            <input
              type='text'
              name='jawatan'
              className='item_pic_input'
              value={payload.jawatan}
              placeholder={newObj.PositionWord[language]}
              onChange={handleChangeInput}
            />
            {/* <Dropdown
              selected={payload.pk_code}
              data={pkCode}
              onClick={(item) => {
                setPayload((prev) => ({...prev, pk_code: item}));
              }}
            /> */}

            <input
              type='text'
              name='phone'
              className='item_pic_input'
              value={payload.phone}
              placeholder={newObj.ContactNumberWord[language]}
              onChange={handleChangeInput}
            />
          </div>
          <div className='modal_flexible_btn_ctr'>
            <button type='submit' disabled={loading}>
              {newObj.SaveWord[language]}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
